<template>
  <div>
    <Header />
    <Details />
    <Footer />
    <SocialLinks />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import Details from '../components/About/Details'
  import Footer from '../components/common/Footer'
  import SocialLinks from '../components/common/SocialLinks'

  export default {
    name: 'ServicedPlots',
    metaInfo: {
      title: 'Serviced Plots',
    },
    components: {
      Header,
      Details,
      Footer,
      SocialLinks
    },
  }
</script>

<style scoped>
</style>